import { Link } from 'react-router-dom';

export default function PoliticaDePrivacidade() {
  return (
    <div className="min-h-screen bg-stone-50">
      {/* Header */}
      <header className="bg-stone-900 py-5 px-6 md:px-12">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/" className="font-black text-white text-lg cursor-pointer">
            TRANSFORMAÇÃO REAL <span className="text-amber-400">60D</span>
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-white/60 hover:text-white text-sm transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            Voltar ao site
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="mb-12">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-stone-400 mb-3">Documento legal</p>
          <h1 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">Política de Privacidade</h1>
          <p className="text-stone-500 text-sm">Última atualização: 15 de abril de 2026</p>
        </div>

        <div className="bg-white rounded-2xl border border-stone-100 p-8 md:p-12 space-y-10 text-gray-700 leading-relaxed">

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">1. Introdução</h2>
            <p className="text-sm leading-relaxed">
              O <strong>Transformação Real 60D</strong> respeita a sua privacidade e está comprometido com a proteção
              dos seus dados pessoais. Esta Política de Privacidade descreve como coletamos, utilizamos, armazenamos e
              protegemos suas informações, em conformidade com a{' '}
              <strong>Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018)</strong> e demais legislações
              aplicáveis.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">2. Dados que Coletamos</h2>
            <p className="text-sm leading-relaxed mb-4">Podemos coletar os seguintes tipos de dados pessoais:</p>
            <div className="space-y-4">
              {[
                {
                  title: 'Dados de identificação',
                  desc: 'Nome completo, CPF/CNPJ, data de nascimento.',
                },
                {
                  title: 'Dados de contato',
                  desc: 'Endereço de e-mail, número de telefone/WhatsApp, endereço.',
                },
                {
                  title: 'Dados empresariais',
                  desc: 'Nome da empresa, segmento de atuação, faturamento aproximado, número de funcionários.',
                },
                {
                  title: 'Dados de navegação',
                  desc: 'Endereço IP, tipo de navegador, páginas visitadas, tempo de permanência no site.',
                },
                {
                  title: 'Dados do quiz de diagnóstico',
                  desc: 'Respostas fornecidas no diagnóstico empresarial, pontuação e nível de maturidade identificado.',
                },
              ].map((item) => (
                <div key={item.title} className="bg-stone-50 rounded-xl p-4">
                  <p className="text-sm font-bold text-gray-900 mb-1">{item.title}</p>
                  <p className="text-sm text-gray-600">{item.desc}</p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">3. Como Utilizamos seus Dados</h2>
            <p className="text-sm leading-relaxed mb-3">Seus dados são utilizados para:</p>
            <ul className="space-y-2 text-sm">
              {[
                'Processar sua inscrição e gerenciar sua participação no programa',
                'Enviar materiais, comunicados e atualizações relacionados ao programa',
                'Personalizar o diagnóstico e as recomendações empresariais',
                'Entrar em contato via WhatsApp ou e-mail para suporte e acompanhamento',
                'Melhorar nossos serviços com base em análises de uso',
                'Cumprir obrigações legais e regulatórias',
                'Enviar comunicações de marketing (apenas com seu consentimento)',
              ].map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 shrink-0 mt-2" />
                  {item}
                </li>
              ))}
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">4. Base Legal para o Tratamento</h2>
            <p className="text-sm leading-relaxed">
              O tratamento dos seus dados pessoais é realizado com base nas seguintes hipóteses legais previstas na
              LGPD: <strong>consentimento</strong> do titular, <strong>execução de contrato</strong> ou procedimentos
              preliminares, <strong>cumprimento de obrigação legal</strong> e{' '}
              <strong>legítimo interesse</strong> do controlador, sempre respeitando os direitos e liberdades
              fundamentais do titular.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">5. Compartilhamento de Dados</h2>
            <p className="text-sm leading-relaxed mb-3">
              Não vendemos seus dados pessoais. Podemos compartilhá-los apenas nas seguintes situações:
            </p>
            <ul className="space-y-2 text-sm">
              {[
                'Com prestadores de serviços que auxiliam na operação do programa (plataformas de pagamento, e-mail marketing, CRM)',
                'Com autoridades públicas, quando exigido por lei ou ordem judicial',
                'Com parceiros de negócio, somente mediante seu consentimento expresso',
              ].map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 shrink-0 mt-2" />
                  {item}
                </li>
              ))}
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">6. Armazenamento e Segurança</h2>
            <p className="text-sm leading-relaxed">
              Seus dados são armazenados em servidores seguros com criptografia e controles de acesso adequados.
              Adotamos medidas técnicas e organizacionais para proteger suas informações contra acesso não autorizado,
              perda, destruição ou divulgação indevida. Os dados são mantidos pelo tempo necessário para cumprir as
              finalidades descritas nesta política ou conforme exigido por lei.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">7. Cookies e Tecnologias de Rastreamento</h2>
            <p className="text-sm leading-relaxed">
              Nosso site pode utilizar cookies e tecnologias similares para melhorar sua experiência de navegação,
              analisar o tráfego e personalizar conteúdos. Você pode configurar seu navegador para recusar cookies,
              mas isso pode afetar algumas funcionalidades do site. Ao continuar navegando, você consente com o uso
              de cookies conforme descrito nesta política.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">8. Seus Direitos como Titular</h2>
            <p className="text-sm leading-relaxed mb-3">
              Conforme a LGPD, você tem os seguintes direitos em relação aos seus dados pessoais:
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                { icon: 'ri-eye-line', title: 'Acesso', desc: 'Confirmar a existência e acessar seus dados' },
                { icon: 'ri-edit-line', title: 'Correção', desc: 'Corrigir dados incompletos ou desatualizados' },
                { icon: 'ri-delete-bin-line', title: 'Exclusão', desc: 'Solicitar a eliminação dos seus dados' },
                { icon: 'ri-file-transfer-line', title: 'Portabilidade', desc: 'Receber seus dados em formato estruturado' },
                { icon: 'ri-close-circle-line', title: 'Revogação', desc: 'Retirar o consentimento a qualquer momento' },
                { icon: 'ri-information-line', title: 'Informação', desc: 'Saber com quem seus dados são compartilhados' },
              ].map((right) => (
                <div key={right.title} className="bg-stone-50 rounded-xl p-4 flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-amber-100 shrink-0">
                    <i className={`${right.icon} text-amber-600 text-sm`} />
                  </div>
                  <div>
                    <p className="text-sm font-bold text-gray-900">{right.title}</p>
                    <p className="text-xs text-gray-500 mt-0.5">{right.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <p className="text-sm leading-relaxed mt-4">
              Para exercer qualquer um desses direitos, entre em contato pelo e-mail:{' '}
              <strong>contato@xlabstudio.com.br</strong>. Responderemos em até 15 dias úteis.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">9. Transferência Internacional de Dados</h2>
            <p className="text-sm leading-relaxed">
              Alguns de nossos fornecedores de tecnologia podem estar localizados fora do Brasil. Nesses casos,
              garantimos que a transferência de dados ocorre em conformidade com a LGPD, adotando salvaguardas
              adequadas para proteger suas informações.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">10. Alterações nesta Política</h2>
            <p className="text-sm leading-relaxed">
              Esta Política de Privacidade pode ser atualizada periodicamente. Notificaremos sobre mudanças
              significativas por e-mail ou por aviso em destaque no site. A data da última atualização sempre
              estará indicada no topo deste documento.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">11. Encarregado de Dados (DPO)</h2>
            <p className="text-sm leading-relaxed">
              Para questões relacionadas à proteção de dados pessoais, entre em contato com nosso encarregado:
            </p>
            <div className="mt-4 bg-stone-50 rounded-xl p-5 space-y-2 text-sm">
              <p><strong>Transformação Real 60D</strong></p>
              <p>Manaus, Amazonas — AM, Brasil</p>
              <p>E-mail: contato@xlabstudio.com.br</p>
              <p>WhatsApp: (92) 98439-8338</p>
            </div>
          </section>

        </div>

        {/* Bottom nav */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link
            to="/"
            className="flex items-center gap-2 text-stone-500 hover:text-stone-800 text-sm transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            Voltar ao site
          </Link>
          <Link
            to="/termos-de-uso"
            className="flex items-center gap-2 text-stone-500 hover:text-stone-800 text-sm transition-colors cursor-pointer"
          >
            Ver Termos de Uso
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-stone-900 py-6 px-6 mt-8">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs">© 2026 Transformação Real 60D. Todos os direitos reservados.</p>
          <div className="flex items-center gap-6">
            <Link to="/termos-de-uso" className="text-white/30 hover:text-white/60 text-xs transition-colors">Termos de Uso</Link>
            <Link to="/politica-de-privacidade" className="text-amber-400 text-xs font-semibold">Política de Privacidade</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
